<template>
  <v-card
      v-on:mouseover="elevation = 10"
      v-on:mouseleave="elevation = 2"
      :elevation="elevation"
      :height="130"
      class="pl-2 pt-2"
  >

    <div class="d-flex flex-no-wrap justify-space-between align-center">

      <div style="position: relative;">
        <v-avatar tile size="45px">
          <v-img :src="getImage" :style="{
            backgroundColor: getBackgroundColor,
            border: getBorder,
            opacity: hasStock ? 1 : 0.3
          }">


          </v-img>
        </v-avatar>
        <div
            v-if="!hasStock"
            class="body-2 text-center"
            :style="{
                position: 'absolute',
                top:'0px',
                right:'0px',
                color: 'black',
                fontWeight: 'bold',
                opacity: 1
              }"
        >
          <span>Sin Stock</span>
        </div>
      </div>

      <div class="title font-weight-bold text-left flex-grow-1 pl-3" :style="{color: getFontColor}">
        <v-clamp autoresize :max-lines="1" >
          {{ product.name.charAt(0).toUpperCase() + product.name.toLowerCase().substring(1) }}
        </v-clamp>
      </div>

    </div>
    <v-card-actions class="py-0" :style="{height: '70px'}" >
      <span  class="grey--text pr-2 font-raleway" >{{product.description}}</span>
      <v-spacer></v-spacer>
      <div class="d-flex justify-center align-center" :style="{height: '70px'}">
      <!--REMOVE-->
      <v-btn v-if="editQuantity && quantity > 0"
             fab small outlined
             color="red"
             @click="removeProduct(product, category)"
      >
        <v-icon>{{ quantity === 1 ? 'delete' : 'remove' }}</v-icon>
      </v-btn>
      <!--SHOW-->
      <span v-if="quantity > 0" class="px-3">x{{ quantity }}</span>
      <!--ADD-->
      <v-btn v-if="editQuantity"
             fab small
             :color="hasStock ? getFontColor : 'red darken--1'" dark
             @click="addProduct(product, category, order)"
      >
        <v-icon>{{ hasStock ? 'add' : 'dangerous' }}</v-icon>
      </v-btn>
      </div>
    </v-card-actions>

  </v-card>


</template>

<script>

import VClamp from 'vue-clamp'

export default {
  name: "PromoProductCard",
  components: {
    VClamp
  },
  props: {
    product: Object,
    category: Object,
    quantity: Number,
    order: {type: Number, default: 999},
    stockQuantity: {type: Number, default: 1000},
    editQuantity: {type: Boolean, default: false},
  },
  data() {
    return {
      elevation: 2
    }
  },
  computed: {
    hasStock() {
      return (this.quantity < this.stockQuantity)
    },
    getImage() {
      let imageCategory
      if (this.product.imageCategory) {
        imageCategory = this.product.imageCategory.find(i => i.category === this.category.id)
      }
      return (imageCategory && imageCategory.image) ? imageCategory.image : this.product.image
    },
    getPrice() {
      return this.product.price + (this.category.surcharge ? this.category.surcharge : 0)
    },
    getSize() {
      switch (this.$store.getters.galleryView) {
        case 12:
          return 'LARGE'
        case 6:
          return 'MEDIUM'
        case 4:
          return 'SMALL'
        default:
          return 'SMALL'
      }
    },
    getHeight() {
      switch (this.getSize) {
        case 'LARGE':
          return this.$vuetify.breakpoint.smAndDown ? 290 : 145
        default:
          return 290
      }
    },
    getMdPicture() {
      switch (this.getSize) {
        case 'LARGE':
          return 4
        default:
          return 12
      }
    },
    getMdText() {
      switch (this.getSize) {
        case 'LARGE':
          return 8
        default:
          return 12
      }
    },
    getBackgroundColor() {
      return this.category.backgroundColor ? this.category.backgroundColor : null
    },
    getBorder() {
      return this.category.borderColor ? 'solid 2px ' + this.category.borderColor : null
    },
    getFontColor() {
      return this.category.fontColor ? this.category.fontColor : null
    },
    getIconColor() {
      return this.category.iconColor ? this.category.iconColor : null
    },
    getIcon() {
      return this.category.icon ? this.category.icon : null
    }
  },
  methods: {
    addProduct(product, category, order) {
      if (this.quantity < this.stockQuantity) {
        this.$emit('addItem', {product, category, order})
      }
    },
    removeProduct(product, category) {
      this.$emit('removeItem', {product, category})
    },
  }
}
</script>

<style scoped>
.semiTransparent {
  opacity: 0.5;
}
</style>
